import React, {useContext, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux'
import {useNavigate, Link} from "react-router-dom";
import logo from '../../assets/mvp-logo-black.svg';
import * as Routes from "../../utils/routes";
import loginButton from '../../assets/login-button.png';
import {getAuth, signInWithEmailAndPassword, signOut} from "firebase/auth";
import app from '../../utils/firebase';
import * as userActions from '../../redux/User/actions';
import ball1 from '../../assets/home/ball1.png';
import ball2 from '../../assets/home/ball2.png';
import ball3 from '../../assets/home/ball3.png';
import FloatingImage from "../../components/FloatingImage";
import LoadingPanel from "../../components/LoadingPanel";

import './SignInPage.scss';
import constants from '../../utils/constants';
import Toaster from '../../components/Toaster';

const auth = getAuth(app);

const SigninPage = props => {
	const [loading, setLoading] = useState(false);
	const [pass, setPass] = useState("");
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();

	const dispatch = useDispatch();

	useEffect(() => {
		signOut(auth).then(res => {
			console.log("signed out");
		})
	}, []);

	const doSignin = async () => {
		setError("");

		if(pass.length < 1 || email.length < 1) {
			setError("Please fill both fields.");
		}
		else {
			await setLoading(true);
			signInWithEmailAndPassword(auth, email, pass)
				.then(async () => {
					localStorage.setItem(constants.IS_INTERNAL_LOGIN, 'false')
					await setLoading(false);
					const idToken = await auth.currentUser.getIdToken(/* forceRefresh */ true);
					await dispatch(userActions.signIn(idToken, onSuccess, onFail));
				})
				.catch(async error => {
					await setLoading(false);
					const errorCode = error.code;
					console.log(errorCode);
					if(errorCode === "auth/invalid-email") {
						setError("Invalid credentials.");
					}
					else {
						console.log(errorCode);
					}
				});
		}
	};

	const onSuccess = () => {
		navigate(Routes.HOME);
	};

	const onFail = () => {
		Toaster.showError('Login failed')
		console.log("login failed");
		setLoading(false);
	};

	return (
		<div className="signin-container">

			{ loading && <LoadingPanel /> }

			<img src={logo} alt="" className="signin-logo" />

			<div style={{position: 'absolute', bottom: '100px', left: '20vw'}}>
				<FloatingImage src={ball1} uid="ball1" animationDuration={2500} fromValue={0} toValue={-150} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', left: '30vw'}}>
				<FloatingImage src={ball2} uid="ball2" animationDuration={1500} fromValue={-40} toValue={-120} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', right: '20vw'}}>
				<FloatingImage src={ball3} uid="ball3" animationDuration={5000} fromValue={0} toValue={-230} />
			</div>

			<form>
				<div className="signin-box-wrapper">
					<div className="signin-box">
						<div/>
						<div style={{fontSize: '19px', color: '#142A31', fontWeight: 700}}>Sign In</div>

						<div className="signin-description">
							Use your login information to sign in
						</div>

						<br/>

						<input type="text" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} className="signin-input" placeholder="Email" />
						<input type="password" autoComplete="off" value={pass} onChange={e => setPass(e.target.value)} className="signin-input" placeholder="Password" />

						<div className="signin-error">{error}&nbsp;</div>

						<img src={loginButton} alt="" className="signin-button" onClick={doSignin} />

						<br/>
						<Link to={Routes.FORGOT_PASSWORD} className="signin-forgot-password">Forgot your password?</Link>
					</div>
				</div>
			</form>

			<div className="email-row">Email us at <a href="mailto:support@connact.cloud"><b>support@connact.cloud</b></a> for any issues</div>
		</div>
	)
};

export default SigninPage;
